import type {
  CoinmarketcapFearGreedData,
  GetAssetCategoriesData,
  RegistryproviderAssetCategoriesResponse,
} from '@polaris/api-client'
import { apiClient } from './client'

export const getFearAndGreedIndex = (): Promise<CoinmarketcapFearGreedData> =>
  apiClient
    .get('market-trends/fear-and-greed-index', {
      next: {
        // Aligned with backend cache: 30min (app/integrations/coinmarketcap/provider.go:115 - fearGreedCache)
        revalidate: 60 * 30, // 30 minutes
        tags: ['market-trends', 'fear-greed'],
      },
    })
    .json<CoinmarketcapFearGreedData>()

export const get24hMarketCapChange = (): Promise<number> =>
  apiClient
    .get('market-trends/24h-market-cap-change', {
      next: {
        // Aligned with backend cache: 10min (app/integrations/coingecko/provider.go:257 - globalDataCache)
        revalidate: 60 * 10, // 10 minutes
        tags: ['market-trends', 'market-cap'],
      },
    })
    .json<number>()

export type GetAssetCategoriesOrder = NonNullable<
  GetAssetCategoriesData['query']
>['order']

export const getAssetCategories = (order?: GetAssetCategoriesOrder) => {
  const searchParams = new URLSearchParams()
  if (order) {
    searchParams.append('order', order)
  }

  return apiClient
    .get('asset-categories', {
      searchParams: searchParams.toString(),
      next: {
        // Aligned with backend cache: 10min (app/integrations/coingecko/provider.go:259 - categoriesWithMarketDataDataCache)
        revalidate: 60 * 10, // 10 minutes
        tags: ['market-trends', 'asset-categories'],
      },
    })
    .json<RegistryproviderAssetCategoriesResponse>()
}
